import { styled } from "sharedUI/styles";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Button } from "designer/ui/smart/button/button-style";
import { OrgIcon } from "designer/apps/orgs/orgs-sidebar/org-icon";
import { useSelector } from "react-redux";
import { RootState } from "store/types";
import InviteMembers from "./invite-members"
import { assertNever } from "common/Support";

const CreateTeamStyle = styled.div`
    display: flex;
    flex-direction: column;

    > * {
        width: 100%;    
    }

    small {
        font-size: 14px;
        color: ${p => p.theme.n700A};
    }

    > hgroup {
        margin-bottom: 12px;

        h1 {
            font-size: 26px;
            font-weight: 800;
            margin-top: 12px;
        }
    }

    button {
        cursor: pointer;
    }

    .invite-label {
        font-weight: 600;
        font-size: 14px;
        color: ${p => p.theme.n800A};
    }

    .email-input {
        margin-top: 20px;
    }

    .email-send-button button,
    .invite-link button {
        width: 100%;
        margin: 16px 0 0 0;
    }

    .skip {
        font-size: 13px;
        margin-top: 20px;
        justify-content: center;
        display: flex;
    }

    .lets-go button {
        width: 100%;
        margin: 24px 0 0 0;
    }
`;

interface CreatedTeamProps extends RouteComponentProps {
    onDone: () => void;
    orgID: string;
}

type Stage = "invite" | "done"

const CreatedTeamImpl: React.FunctionComponent<CreatedTeamProps> = ({
    orgID, onDone
}) => {
    const orgs = useSelector((state: RootState) => state.organizations);
    const org = orgs.find(o => o.id === orgID);
    const orgDisplayName = org?.displayName || "";
    const [stage, setStage] = React.useState<Stage>("invite");

    switch(stage) {
        case "invite": {
            return <CreateTeamStyle>
                <InviteMembers
                    orgID={orgID}
                    onDone={() => setStage("done")}
                    source="new_team_flow"
                />
            </CreateTeamStyle>
        }
        case "done": {
            return <CreateTeamStyle>
                <hgroup>
                    <OrgIcon size={"xlarge"} label={orgDisplayName} />
                    <h1>Welcome to {orgDisplayName}</h1>
                </hgroup>
                <small>
                    Your team is ready! You can create as many apps as you like, and invite team members to collaborate.
                </small>
                <div className="lets-go">
                    <Button
                        variant="filled"
                        onClick={onDone}
                        tallerVariation={true}
                    >
                        Let's Go
                    </Button>
                </div>
            </CreateTeamStyle>
        }
        default:
            return assertNever(stage);
    }
};

const CreatedTeam = withRouter(CreatedTeamImpl);
export default CreatedTeam;
